import React from 'react';
import classes from './HandlingUserData.module.css';

const en = (props) => (
  <div className={classes.Content}>
    {props.indexPage
      ? <div>
        <p style={{marginBottom: props.indexPage ? '1rem' : 0}}> <b> Lataa tiedot </b> </p>
        <p> Voit ladata tietosi seuraavalle sivulle <br />
          Asetukset > Asetukset > Tiedonhallinta > Lataa tiedot
        </p> <br />
        <div className={classes.HrLine} />
        <br />
      </div>
      : null}
    <p style={{textAlign: props.indexPage ? 'left' : 'center'}}> <b> Pyydä tietojen poistamista </b> </p> <br />
    <p> Voit pyytää tietojen poistamista seuraavasti: </p> <br />
    <p> Siirry Ota yhteyttä -sivulle <br />
      Valitse vaihtoehto "Poista tili ja kaikki tietoni". <br />
      Paina Lähetä <br /> <br />
    </p>
    <p> CS -tiimimme poistaa kaikki tietosi 24 tunnin kuluessa. </p>
  </div>
);

export default en;



// WEBPACK FOOTER //
// ./src/assets/localization/hud/fi.js